import { Component, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';
import { AuthorizeService } from '../_core/access-control/authorize.service';
import { UserState } from '../_shared/state/user.state';
import { AppState } from '../app.state';

@Component({
  selector: 'app-discover-clients',
  templateUrl: './discover-clients.component.html',
  styleUrls: ['./discover-clients.component.scss'],

})
export class DiscoverClientsComponent implements OnInit {

  companyAppConfig: any;
  displayExpiredListings: boolean;
  onDestroyNotifier$ = new Subject();
  isAgent: boolean = false;
  tabIndex: number;
  constructor(
    private appState: AppState,
    private userState: UserState,
    public authorizeService: AuthorizeService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.appState.companyInfo$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res) {
        this.companyAppConfig = res?.appConfig;
        if (this.companyAppConfig?.expiredListings?.enabled) {
          this.displayExpiredListings = true;
        }

      }
    });
    this.userState.userDetail$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res) {

        // const clientData = this.constructClientDetailSheet()
        if (res?.userType == 'agent') {
          this.isAgent = true;
        }
      }
    });

    this.route.queryParamMap
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(params => {
        const tab = params.get('tab');
        if (tab == 'expiredListings') {
          this.tabIndex = 1;

        } else if (tab == 'pastClients') {
          this.tabIndex = 0;
        } else {
          this.tabIndex = 0;

        }
      });
  }
  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }
  updateUrl(tabName: string) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab: tabName }
    });


  }

  onTabChange(event: MatTabChangeEvent) {
    if (event.tab.ariaLabel === 'Expired Listings') {
      this.updateUrl('expiredListings');
    }
    if (event.tab.ariaLabel === 'pastClients') {
      this.updateUrl('pastClients');
    }
  }

}
